import { render, staticRenderFns } from "./PortalBooleanField.vue?vue&type=template&id=6fcc098a"
import script from "./PortalBooleanField.vue?vue&type=script&lang=ts"
export * from "./PortalBooleanField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports